import TalentImg1 from "../../images/Rectangle_1325.png"
import TalentImg2 from "../../images/Rectangle_1328.png"
import TalentImg3 from "../../images/Rectangle_1273.png"
import TalentImg4 from "../../images/Rectangle_1275.png"
import TalentImg5 from "../../images/Rectangle_1277.png"
import TalentImg6 from "../../images/Rectangle_1326.png"
import TalentImg7 from "../../images/Rectangle_1327.png"
import ProfilePic from "../../images/Ellipse_170.png"
import Location from "../../images/Icon-material-location-on.png"

class HireTalentAPI {
    static talentPages = {
        "online-typing": {
            name: "Online Typing",
            to: "/hire-talent/online-typing",
            image: TalentImg1,
            types: ["Graphics Design", "Banner Ad Design", "Art And Illustration", "Logo Design", "Broucher Design"]
        },
        "video-editing": {
            name: "Video Editing",
            to: "/hire-talent/video-editing",
            image: TalentImg2,
            types: ["Graphics Design", "Banner Ad Design", "Art And Illustration", "Logo Design", "Broucher Design"]
        },
        "graphics-design": {
            name: "Graphics & Design",
            to: "/hire-talent/graphics-design",
            image: TalentImg3,
            types: ["Graphics Design", "Banner Ad Design", "Art And Illustration", "Logo Design", "Broucher Design"]
        },
        "typing-jobs": {
            name: "Typing Jobs",
            to: "/hire-talent/typing-jobs",
            image: TalentImg4,
            types: ["Graphics Design", "Banner Ad Design", "Art And Illustration", "Logo Design", "Broucher Design"]
        },
        "content-writing": {
            name: "Content Writing",
            to: "/hire-talent/content-writing",
            image: TalentImg5,
            types: ["Graphics Design", "Banner Ad Design", "Art And Illustration", "Logo Design", "Broucher Design"]
        }
    };

    static talents = [{
        image: TalentImg1,
        to: '/hire-talent/typing-jobs/Graphics Design/122',
        title: 'Typing Jobs',
        desc: 'I Can Do 50 Data Entry Projects On Various',
        allDesc: 'As a business owner or manager, what would it look like to have as the data entry',
        profilePic: ProfilePic,
        profileName: 'Kaira',
        locationPic: Location,
        location: 'Chennai',
        pay: '500',
        payUnit: 'Day'
    },
    {
        image: TalentImg2,
        title: 'Graphics Design',
        to: '/hire-talent/graphics-design/Graphics Design/122',
        desc: 'I Can Do 50 Data Entry Projects On Various',
        allDesc: 'As a business owner or manager, what would it look like to have as the data entry',
        profilePic: ProfilePic,
        profileName: 'Kaira',
        locationPic: Location,
        location: 'Chennai',
        pay: '500',
        payUnit: 'Day'
    },
    {
        image: TalentImg6,
        title: 'Video Editing',
        to: '/hire-talent/video-editing/Graphics Design/122',
        desc: 'I Can Do 50 Data Entry Projects On Various',
        allDesc: 'As a business owner or manager, what would it look like to have as the data entry',
        profilePic: ProfilePic,
        profileName: 'Kaira',
        locationPic: Location,
        location: 'Chennai',
        pay: '500',
        payUnit: 'Day'
    },
    {
        image: TalentImg7,
        title: 'Content Writing',
        to: '/hire-talent/content-writing/Graphics Design/122',
        desc: 'I Can Do 50 Data Entry Projects On Various',
        allDesc: 'As a business owner or manager, what would it look like to have as the data entry',
        profilePic: ProfilePic,
        profileName: 'Kaira',
        locationPic: Location,
        location: 'Chennai',
        pay: '500',
        payUnit: 'Day'
    }];
    static fetchHireTalentJobs = (type, subType = undefined, page = 1, searchInput = '', filters = {}) => {
        //change this api calling logic with actual API
        const res = this.talents.slice(page % this.talents.length).concat(this.talents.slice(0, page % this.talents.length));
        return [...res, ...res, ...res];
    }

    static fetchTalents = (limit = 8, offset = 0) => {
        //change this api calling logic with actual API
        return [...this.talents, ...this.talents, ...this.talents].splice(offset, limit);
    }
}
export default HireTalentAPI;